<!-- <app-sidenav-content></app-sidenav-content> -->

<!-- <app-sidenav-demo></app-sidenav-demo> -->
<app-loader></app-loader>
<router-outlet></router-outlet>